
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import TranslatedText from '@/TranslatedText';

const EmptyCartMessage: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="text-center py-12">
      <h2 className="text-xl font-medium mb-4">
        <TranslatedText text="Your cart is empty" />
      </h2>
      <p className="text-gray-500 mb-6">
        <TranslatedText text="Looks like you haven't added any products to your cart yet." />
      </p>
      <Button 
        onClick={() => navigate('/')} 
        className="bg-ahavex-blue hover:bg-ahavex-darkblue text-white font-medium" 
        variant="default"
      >
        <TranslatedText text="Return to Shop" />
      </Button>
    </div>
  );
};

export default EmptyCartMessage;
